// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sm3g","content":"styles_content__1vu55","tableWrap":"styles_tableWrap__3T-Si"};